import { render, staticRenderFns } from "./PeriodParent.vue?vue&type=template&id=4cb1ac6a&scoped=true"
import script from "./PeriodParent.vue?vue&type=script&lang=js"
export * from "./PeriodParent.vue?vue&type=script&lang=js"
import style0 from "./PeriodParent.vue?vue&type=style&index=0&id=4cb1ac6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1ac6a",
  null
  
)

export default component.exports